const HIGHLIGHT_NAME = 'command-menu-search';

let styleInjected = false;

const ensureHighlightStyle = () => {
  if (styleInjected || typeof document === 'undefined' || !CSS.highlights) {
    return;
  }

  const style = document.createElement('style');
  style.textContent = `::highlight(${HIGHLIGHT_NAME}) { background-color: var(--chakra-colors-yellow-200); color: inherit; }`;
  document.head.appendChild(style);
  styleInjected = true;
};

export const highlightMatches = (container: HTMLElement | null, searchText: string) => {
  if (!CSS.highlights) {
    return;
  }

  ensureHighlightStyle();

  CSS.highlights.delete(HIGHLIGHT_NAME);

  if (!container || !searchText) {
    return;
  }

  const ranges: Range[] = [];
  const lowerSearch = searchText.toLowerCase();
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);

  for (let node = walker.nextNode() as Text | null; node; node = walker.nextNode() as Text | null) {
    const text = node.textContent?.toLowerCase();

    if (!text) {
      continue;
    }

    let startIndex = 0;

    while (startIndex < text.length) {
      const matchIndex = text.indexOf(lowerSearch, startIndex);

      if (matchIndex === -1) {
        break;
      }

      const range = new Range();
      range.setStart(node, matchIndex);
      range.setEnd(node, matchIndex + searchText.length);
      ranges.push(range);
      startIndex = matchIndex + searchText.length;
    }
  }

  if (ranges.length > 0) {
    CSS.highlights.set(HIGHLIGHT_NAME, new Highlight(...ranges));
  }
};

export const clearHighlightMatches = () => {
  CSS.highlights?.delete(HIGHLIGHT_NAME);
};
